export default __webpack_public_path__ + "static/media/8.1ff6a361.png";